import type { PresentationDeck } from '@/types/presentation';

export const DEFAULT_SECTIONS = [
  'Concepto',
  'Journey del evento',
  'Minuto a minuto',
  'Zona Instagrameable',
  'Cámara 360',
  'Photobooth',
  'Cabina Espejada',
  'Cubos Volumétrico',
  'Backing Banner',
  'Banner Rollup',
  'Renders',
];

/** Merge default sections with any extra sections entered by the user. */
export function buildPresentationSections(extraSections: string): string[] {
  const extras = extraSections
    .split('\n')
    .map((s) => s.trim())
    .filter(Boolean);
  const seen = new Set(DEFAULT_SECTIONS);
  const result = [...DEFAULT_SECTIONS];
  for (const extra of extras) {
    if (!seen.has(extra)) {
      seen.add(extra);
      result.push(extra);
    }
  }
  return result;
}

/** Parse pptx_code JSON into a PresentationDeck, handling legacy array format. */
export function parseDeck(pptxCode: string | null | undefined): PresentationDeck {
  if (!pptxCode) return { deck_title: '', slides: [] };
  try {
    const parsed = JSON.parse(pptxCode);
    // Legacy format: plain array of slides
    if (Array.isArray(parsed)) {
      return {
        deck_title: '',
        slides: parsed.map((s) => ({
          section: '',
          title: s.title || '',
          subtitle: s.subtitle || '',
          bullets: s.bullets || [],
          layout: 'content' as const,
          speaker_notes: '',
          image_prompt: '',
        })),
      };
    }
    return parsed as PresentationDeck;
  } catch {
    return { deck_title: '', slides: [] };
  }
}

/** Serialize a PresentationDeck to JSON for storage. */
export function stringifyDeck(deck: PresentationDeck): string {
  return JSON.stringify(deck);
}
